import {
  ForeignKeyField,
  NumberField,
  RangeInc,
  RemoteChildDataSource,
  Required,
  Schema,
  TextField
} from "lego-gui-lib";
import { api, mainStore } from "../../core/mainStore";
import { CustomerFK } from "../customer/schema";
import { t } from "../../core/i18n/i18n";
import { CustomerMessagesFK } from "../message/schema";
import {
  queryParamDtoStrategy,
  queryParamParentChangeStrategy
} from "lego-gui-lib/lib/dataAccess/ChildDataSourceStrategies";
import { Auth } from "../../core/model/auth";

export const QueueConfigurationSchema = new Schema({
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.ANYONE,
    editableRole: Auth.Roles.ANYONE_WITH_WRITE
  },
  groups: {
    "common:main": t("common:main"),
    "hns:message:domain_plural": t("hns:message:domain_plural")
  },
  fields: [
    {
      name: "customerRef",
      type: CustomerFK,
      sort: { field: "name" },
      title: t("hns:queueConfig:customerRef"),
      group: "common:main"
    },
    {
      name: "sanRef",
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      type: () => require("../san/schema").SANFK,
      sort: { field: "name" },
      title: t("hns:queueConfig:sanRef"),
      group: "common:main"
    },
    {
      name: "name",
      type: TextField(Required),
      title: t("common:name"),
      group: "common:main"
    },
    {
      name: "queueSize",
      type: NumberField(Required, RangeInc(1, 300)),
      title: t("hns:queueConfig:queueSize"),
      group: "common:main"
    },
    {
      name: "queueMaxWaitTime",
      type: NumberField(Required, RangeInc(60, 86400)),
      title: t("hns:queueConfig:queueMaxWaitTime"),
      group: "common:main"
    },
    {
      name: "queueMaxConRetries",
      type: NumberField(Required, RangeInc(1, 100)),
      title: t("hns:queueConfig:queueMaxConRetries"),
      group: "common:main"
    },
    {
      name: "queueRetryPeriod",
      type: NumberField(Required, RangeInc(1, 600)),
      title: t("hns:queueConfig:queueRetryPeriod"),
      group: "common:main"
    },
    {
      name: "msgQueueGreetingRef",
      type: CustomerMessagesFK,
      title: t("hns:queueConfig:msgQueueGreetingRef"),
      group: "hns:message:domain_plural"
    },
    {
      name: "msgQueueOnHoldRef",
      type: CustomerMessagesFK,
      title: t("hns:queueConfig:msgQueueOnHoldRef"),
      group: "hns:message:domain_plural"
    },
    {
      name: "msgQueueFullRef",
      type: CustomerMessagesFK,
      title: t("hns:queueConfig:msgQueueFullRef"),
      group: "hns:message:domain_plural"
    },
    {
      name: "msgQueueExitRef",
      type: CustomerMessagesFK,
      title: t("hns:queueConfig:msgQueueExitRef"),
      group: "hns:message:domain_plural"
    }
  ]
});

export const QueueConfigurationSchemaShowAndCreate = QueueConfigurationSchema.extend(
  {
    customerRef: false,
    sanRef: false
  }
);

export const QueueConfigurationSchemaColumns = QueueConfigurationSchemaShowAndCreate.extend(
  {
    msgQueueGreetingRef: false,
    msgQueueOnHoldRef: false,
    msgQueueFullRef: false,
    msgQueueExitRef: false
  }
);

mainStore.queueConfiguration = RemoteChildDataSource.create({
  parent: mainStore.SAN.oneDataSource,
  parentChangedStrategy: queryParamParentChangeStrategy("id", "sanRef"),
  dtoStrategy: queryParamDtoStrategy("id", "sanRef"),
  api: api,
  name: "queueConfiguration",
  schema: QueueConfigurationSchema,
  url: "/queueConfigurations",
  commons: mainStore.commons
});

mainStore.queueConfigurationFk = RemoteChildDataSource.clone(
  mainStore.queueConfiguration
);

export const QueueConfigurationFK = ForeignKeyField(
  {
    dataSource: mainStore.queueConfigurationFk.listDataSource,
    labelField: "name",
    valueField: "id",
    minWidth: 70
  },
  Required
);

export const QueueConfigurationFKNotRequired = ForeignKeyField({
  dataSource: mainStore.queueConfigurationFk.listDataSource,
  labelField: "name",
  valueField: "id",
  minWidth: 70
});
